import VoucherPDFBatch from 'src/PDF/VoucherPDFBatch'

const JvPaymentVoucherBundlePDF = (voucherBundle) => VoucherPDFBatch(voucherBundle)

export default JvPaymentVoucherBundlePDF
